var map = {
	"./atticus.png": 756,
	"./blikopzeewolde.png": 757,
	"./bosscheomroep.png": 758,
	"./brugnieuws.png": 759,
	"./destadskoerier.png": 760,
	"./deswollenaer.png": 761,
	"./drontenaar.png": 762,
	"./heerdeonline.png": 763,
	"./qumedia.png": 764,
	"./rozet.png": 765,
	"./vijftigplus.png": 766,
	"./zeewoldeactueel.png": 767,
	"./zeewoldeactueel_old.png": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;